export enum TemplateResolutionKey {
  SQUARE = '1:1',
  PORTRAIT_9_16 = '9:16',
  LANDSCAPE_16_9 = '16:9',
  /** Match video review templates only: the review MP4 is 1920×1080, a smaller plate would be scaled up blurred. */
  VIDEO_FULL_HD = '16:9 video',
}

export interface TemplateResolution {
  key: TemplateResolutionKey;
  label: string;
  width: number;
  height: number;
}

export const TEMPLATE_RESOLUTIONS: Record<TemplateResolutionKey, TemplateResolution> = {
  [TemplateResolutionKey.SQUARE]: {
    key: TemplateResolutionKey.SQUARE,
    label: '1:1 (1080×1080)',
    width: 1080,
    height: 1080,
  },
  [TemplateResolutionKey.PORTRAIT_9_16]: {
    key: TemplateResolutionKey.PORTRAIT_9_16,
    label: '9:16 (720×1280)',
    width: 720,
    height: 1280,
  },
  [TemplateResolutionKey.LANDSCAPE_16_9]: {
    key: TemplateResolutionKey.LANDSCAPE_16_9,
    label: '16:9 (1280×720)',
    width: 1280,
    height: 720,
  },
  [TemplateResolutionKey.VIDEO_FULL_HD]: {
    key: TemplateResolutionKey.VIDEO_FULL_HD,
    label: '16:9 (1920×1080)',
    width: 1920,
    height: 1080,
  },
};

export const TEMPLATE_RESOLUTION_LIST: TemplateResolution[] = Object.values(TEMPLATE_RESOLUTIONS);

export const DEFAULT_TEMPLATE_RESOLUTION = TEMPLATE_RESOLUTIONS[TemplateResolutionKey.SQUARE];

/** The one size of a video review template (IMGM-1606): the size of the review frame. */
export const VIDEO_TEMPLATE_RESOLUTION = TEMPLATE_RESOLUTIONS[TemplateResolutionKey.VIDEO_FULL_HD];

/**
 * Sizes a template of this kind may have: a video template is always the review frame, an image template any size
 * but that one (the server render has never drawn it).
 */
export const templateResolutionsFor = (isVideo: boolean): TemplateResolution[] =>
  isVideo ? [VIDEO_TEMPLATE_RESOLUTION] : TEMPLATE_RESOLUTION_LIST.filter((r) => r !== VIDEO_TEMPLATE_RESOLUTION);

export const resolveTemplateResolution = (width: number, height: number): TemplateResolution =>
  TEMPLATE_RESOLUTION_LIST.find((r) => r.width === width && r.height === height) ?? DEFAULT_TEMPLATE_RESOLUTION;
